import store from 'store';
import { kea } from "kea";

// import { API_KEY } from '../utils

export const preferenceslogic = kea({
	actions: {
		setDrawer: (preferences) => ({ preferences }),
		setVehicle: (preferences) => ({ preferences }),
		setGeofence: (preferences) => ({ preferences }),
		setReplay: (preferences) => ({ preferences }),
		setAssetReplay: (preferences) => ({ preferences }),
		setTracker: (preferences) => ({ preferences }),
		setAsset: (preferences) => ({ preferences }),
	},
	reducers: {
		drawer: [store.get('drawer_preferences') ?? { expand: true }, {
			setDrawer: (_, { preferences }) => {
				store.set('drawer_preferences', preferences);
				return preferences;
			},
		}],
		asset: [store.get('asset_preferences') ?? {
			show: true,
			drag: true,
			expand: false,
			position: {
				x: 10,
				y: 240
			}
		}, {
			setAsset: (_, { preferences }) => {
				store.set('asset_preferences', preferences);
				return preferences;
			},
		}],
		vehicle: [store.get('vehicle_preferences') ?? {
			show: true,
			drag: true,
			expand: false,
			position: {
				x: 10,
				y: 120
			}
		}, {
			setVehicle: (_, { preferences }) => {
				store.set('vehicle_preferences', preferences);
				return preferences;
			},
		}],
		geofence: [store.get('geofence_preferences') ?? {
			show: true,
			drag: true,
			expand: false,
			position: {
				x: 10,
				y: 180
			}
		}, {
			setGeofence: (_, { preferences }) => {
				store.set('geofence_preferences', preferences);
				return preferences;
			},
		}],
		replay: [{
			show: false,
			drag: true,
			position: {
				x: 10,
				y: 240
			}
		}, {
			setReplay: (_, { preferences }) => {
				store.set('replay_preferences', preferences);
				return preferences;
			},
		}],
		assetreplay: [{
			show: false,
			drag: true,
			position: {
				x: 10,
				y: 240
			}
		}, {
			setAssetReplay: (_, { preferences }) => {
				store.set('replay_preferences', preferences);
				return preferences;
			},
		}]
	}
});

export const infowindowlogic = kea({
	actions: {
		set: (vehicle) => ({ vehicle }),
		setPosition: (vehicles) => ({ vehicles }),
	},
	reducers: {
		vehicle: [null, {
			set: (state, { vehicle }) => vehicle,
			setPosition: (state, { vehicles }) => {
				if (!state) return state;
				for (const updated of vehicles) {
					if (updated._id === state._id) {
						state.tracker.status = updated.tracker.status;
						return state;
					}
				}
				return state;
			}
		}],
	}
});


export const assetinfowindowlogic = kea({
	actions: {
		set: (asset) => ({ asset }),
		setPosition: (assets) => ({ assets }),
	},
	reducers: {
		asset: [null, {
			set: (state, { asset }) => asset,
			setPosition: (state, { assets }) => {
				if (!state) return state;
				for (const updated of assets) {
					if (updated._id === state._id) {
						state.beacon.positions = updated.beacon.positions;
						return state;
					}
				}
				return state;
			}
		}],
	}
});

export const assetmaplogic = kea({
	actions: {
		addOne: (asset) => ({ asset }),
		removeOne: (asset) => ({ asset }),
		setAll: (assets) => ({ assets }),
		setPosition: (assets) => ({ assets }),
		setUpdatePosition: (state) => ({ state }),
	},
	reducers: {
		updatePosition: [false, {
			setUpdatePosition: (_, { state }) => state,
			addOne: () => true,
			setAll: () => true,
		}],
		assets: [[], {
			setAll: (state, { asset }) => asset,
			addOne: (state, { asset }) => [...state, asset],
			removeOne: (state, { asset }) => state.filter((s) => asset._id !== s._id),
			setPosition: (state, { assets }) => state.map((outdated) => {
				for (const updated of assets) {
					if (updated._id === outdated._id) {
						outdated.beacon.positions = updated.beacon.positions
					}
				}
				return outdated;
			})
		}]
	},
	listeners: ({ actions, values }) => ({
		removeOne: async () => {
			if (values.assets.length === 1) actions.setUpdatePosition(false);
			else actions.setUpdatePosition(true);
		}
	})
});

export const maplogic = kea({
	actions: {
		addOne: (vehicle) => ({ vehicle }),
		removeOne: (vehicle) => ({ vehicle }),
		setAll: (vehicles) => ({ vehicles }),
		setPosition: (vehicles) => ({ vehicles }),
		setUpdatePosition: (state) => ({ state }),
	},
	reducers: {
		updatePosition: [false, {
			setUpdatePosition: (_, { state }) => state,
			addOne: () => true,
			setAll: () => true,
		}],
		vehicles: [[], {
			setAll: (state, { vehicle }) => vehicle,
			addOne: (state, { vehicle }) => [...state, vehicle],
			removeOne: (state, { vehicle }) => state.filter((s) => vehicle._id !== s._id),
			setPosition: (state, { vehicles }) => state.map((outdated) => {
				for (const updated of vehicles) {
					if (updated._id === outdated._id) {
						outdated.tracker.status = updated.tracker.status
					}
				}
				return outdated;
			})
		}]
	},
	listeners: ({ actions, values }) => ({
		removeOne: async () => {
			if (values.vehicles.length === 1) actions.setUpdatePosition(false);
			else actions.setUpdatePosition(true);
		}
	})
});

export const assetreplaylogic = kea({
	actions: {
		setAsset: (asset) => ({ asset }),
		setMax: (index) => ({ index }),
		setIndex: (index) => ({ index }),
	},
	reducers: {
		asset: [null, {
			setAsset: (state, { asset }) => asset
		}],
		max: [0, {
			setMax: (state, { index }) => index,
		}],
		index: [0, {
			setIndex: (state, { index }) => index,
		}],
	}
});

export const replaylogic = kea({
	actions: {
		setVehicle: (vehicle) => ({ vehicle }),
		setMax: (index) => ({ index }),
		setIndex: (index) => ({ index }),
	},
	reducers: {
		vehicle: [null, {
			setVehicle: (state, { vehicle }) => vehicle
		}],
		max: [0, {
			setMax: (state, { index }) => index,
		}],
		index: [0, {
			setIndex: (state, { index }) => index,
		}],
	}
});